import { useState } from 'react';
import {
  Container,
  InnerContainer,
  ScrollableContainer,
  Title,
  CloseBackGround,
  Header,
  SubTitle,
  SortOptionsWrapper,
  SortOptionTitle,
  SortOptionSectionWrapper,
  RadioButtonsWrapper,
} from './SortModal.styled';
import { sortMobileOptions } from 'src/components/Tickets/MyTickets.constants';
import {
  SortOrder,
  SingleTicketInitial,
} from 'src/components/Tickets/models/Tickets.interface';
import { RadioButton } from '../RadioButton/RadioButton';
import { ModalFooter } from '../ModalFooter/ModalFooter';
import { useServiceDeskContext } from 'src/context/ServiceDesk/ServiceDeskContext';

type LocalSortType = {
  columnId: Partial<keyof SingleTicketInitial> | null;
  sortOrder: SortOrder | null;
};

export const SortModal = () => {
  const { mobileSortToggle, sortTickets, sortedOrder, sortedColumnId } =
    useServiceDeskContext();
  const [radioState, setRadioState] = useState<LocalSortType>({
    columnId: sortedColumnId,
    sortOrder: sortedOrder,
  });

  const handleRadioChange = (value: string) => {
    const [columnId, sortOrder] = value.split(':');
    setRadioState({
      columnId: columnId as Partial<keyof SingleTicketInitial>,
      sortOrder: sortOrder as SortOrder,
    });
  };
  const handleMobileSortClose = () => {
    mobileSortToggle();
  };

  const handleClearAll = () => {
    if (!radioState.columnId && !radioState.sortOrder) {
      handleMobileSortClose();
      return;
    }
    sortTickets(null, null);
    handleMobileSortClose();
  };

  const handleSort = () => {
    if (radioState?.columnId && radioState?.sortOrder) {
      sortTickets(radioState.sortOrder, radioState.columnId);
      handleMobileSortClose();
    }
  };

  return (
    <>
      <CloseBackGround onClick={handleMobileSortClose} />
      <Container>
        <InnerContainer>
          <ScrollableContainer>
            <Header>
              <Title>Sort</Title>
              <SubTitle>
                You can sort the tickets by one criterion only.{' '}
              </SubTitle>
            </Header>
            <SortOptionsWrapper>
              {Object.entries(sortMobileOptions)?.map(([columnId, value]) => {
                const clId = columnId === 'owner' ? '_ownerid_value' : columnId;
                const isAscChecked =
                  radioState.columnId === clId &&
                  radioState.sortOrder === 'asc';
                const isDescChecked =
                  radioState.columnId === clId &&
                  radioState.sortOrder === 'desc';
                const {
                  sortSectionLabel,
                  options: { asc, desc },
                } = value;
                return (
                  <SortOptionSectionWrapper key={columnId}>
                    <SortOptionTitle>{sortSectionLabel}</SortOptionTitle>
                    <RadioButtonsWrapper>
                      <RadioButton
                        value={`${
                          columnId === 'owner' ? '_ownerid_value' : columnId
                        }:${asc.value}`}
                        label={asc.label}
                        checked={isAscChecked}
                        cb={handleRadioChange}
                      />
                      <RadioButton
                        value={`${
                          columnId === 'owner' ? '_ownerid_value' : columnId
                        }:${desc.value}`}
                        label={desc.label}
                        checked={isDescChecked}
                        cb={handleRadioChange}
                      />
                    </RadioButtonsWrapper>
                  </SortOptionSectionWrapper>
                );
              })}
            </SortOptionsWrapper>
          </ScrollableContainer>
          <ModalFooter
            clearAllLabel="Clear all"
            clearAllCB={handleClearAll}
            discardLabel="Discard"
            discardCB={handleMobileSortClose}
            mainActionLabel="Sort"
            mainActionCB={handleSort}
          />
        </InnerContainer>
      </Container>
    </>
  );
};
